import { Box, VStack, Image, Heading, Text, Card } from "@libs/design";

import { Logo } from "../../assets/icons";

import { Login } from "./login";

export const Auth = () => {
  return (
    <Box
      bg="green.500"
      minH="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      px={{ base: 4, md: 6 }}
      py={{ base: 8, md: 10 }}
      gap={{ base: 6, md: 10 }}
    >
      <Image src={Logo} />

      <Card
        variant="outline"
        bg="text.blue.700"
        borderRadius="2xl"
        w="full"
        maxW={"27rem"}
        bodyProps={{ p: { base: 6, md: 8 }, w: "full" }}
        shadow="lg"
      >
        <VStack gap={6} w="full">
          <VStack gap={2} textAlign="center">
            <Heading size={{ base: "2xl", md: "4xl" }} color="text.white">
              Avalon Rise
            </Heading>
            <Text color="gray.700" fontSize={{ base: "sm", md: "md" }}>
              Data Quality Platform Dashboard
            </Text>
          </VStack>

          {/* Login form */}
          <Login />
        </VStack>
      </Card>
    </Box>
  );
};
